import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eDotXetChungChiThamSoXetActionIds, IDotXetChungChiThamSoXetActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiThamSoXet";
import { dotXetChungChiThamSoXetApi } from "../../../api/xet-chung-chi/dotXetChungChiThamSoXetApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IDotXetChungChiThamSoXet } from "../../../model/response/xet-chung-chi/IDotXetChungChiThamSoXet";
const mainActions = rootActions.xetChungChi.dotXetChungChiThamSoXet;

export function* dotXetChungChiThamSoXetSaga(): any {
    yield takeLatest(eDotXetChungChiThamSoXetActionIds.LOAD_BY_DOT_XET_START, loadByDotXetWoker);
    yield takeLatest(eDotXetChungChiThamSoXetActionIds.LOAD_NOT_EXISTS_DOT_XET_START, loadNotExistsDotXetWorker);
    yield takeEvery(eDotXetChungChiThamSoXetActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDotXetChungChiThamSoXetActionIds.DELETE_START, deleteWorker);
}



function* loadByDotXetWoker(action: IDotXetChungChiThamSoXetActionTypes): any {
    const id_dot_xet = action.payload as number;
    const res: IBaseResponse = yield call(dotXetChungChiThamSoXetApi.SelectByDotXet, id_dot_xet);
    if (res.is_success) {
        yield put(mainActions.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainActions.LOAD_BY_DOT_XET_ERROR(res.message ?? "Có lỗi khi tải đợt xét chứng chỉ tham số xét"));
    }
}

function* loadNotExistsDotXetWorker(action: IDotXetChungChiThamSoXetActionTypes): any {
    const id_dot_xet = action.payload as number;
    const res: IBaseResponse = yield call(dotXetChungChiThamSoXetApi.SelectNotExistsDotXet, id_dot_xet);
    if (res.is_success) {
        yield put(mainActions.LOAD_NOT_EXISTS_DOT_XET_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainActions.LOAD_NOT_EXISTS_DOT_XET_ERROR(res.message ?? "Có lỗi khi tải tham số xét chưa có trong đợt xét chứng chỉ"));
    }
}

function* saveWorker(action: IDotXetChungChiThamSoXetActionTypes): any {
    const payload = action.payload as IDotXetChungChiThamSoXet;
    let res: IBaseResponse;
    if (payload.id > 0) {
        res = yield call(dotXetChungChiThamSoXetApi.Update, payload.id, payload);
    } else {
        res = yield call(dotXetChungChiThamSoXetApi.Insert, payload);
    }

    if (res.is_success) {
        yield put(mainActions.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainActions.SAVE_ERROR(res.message ?? "Có lỗi khi lưu đợt xét chứng chỉ tham số xét"));
    }
}



function* deleteWorker(action: IDotXetChungChiThamSoXetActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(dotXetChungChiThamSoXetApi.Delete, id);
    if (res.is_success) {
        yield put(mainActions.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainActions.DELETE_ERROR(res.message ?? "Có lỗi khi xóa đợt xét chứng chỉ tham số xét"));
    }
}